export class configClass {
    constructor() {
      this.url = 'https://web-config-playground-default-rtdb.firebaseio.com/vdrm.json';
      this.loadConfig();
    }
  
    async loadConfig() {
      try {
        const response = await fetch(this.url);
        if (!response.ok) throw new Error('Failed to fetch config');
        
        const data = await response.json();
        localStorage.setItem('appConfig', JSON.stringify(data));
        console.log('✅ Config loaded and stored:', data);
      } catch (error) {
        console.error('❌ Error loading config:', error);
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/modules/appConfig.js